export default "__VITE_ASSET__CFz0iOdf__"